
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
// @ is an alias to /src
import { fetchSpecialOffer } from '@/services/userService';
import store from '@/store';
import BoxSpecialofferLink from '@/components/box/BoxSpecialofferLink/BoxSpecialofferLink.vue';
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";

@Component({
  components: {
    BoxSpecialofferLink,
    LoadingAnimation
  },
})
export default class HomeSpecialoffer extends Vue {
  private name = 'specialoffer';
  private offers: PostDataSpecialoffer[] = [];
  private loading: boolean = false;
  get companyName(): string {
    if (this.lang === 'en') {
      return store.getters['auth/nameEn'];
    } else {
      return store.getters['auth/name'];
    }
  }
  get show(): boolean {
    if (this.offers) {
      return this.offers.length > 0 ? true : false;
    } else {
      return false;
    }
  }
  get lang(): string {
    return this.$store.getters['auth/lang'];
  }
  get memberName(): string {
    if (this.lang === 'en') {
      return 'For only ' + this.companyName;
    } else {
      return this.companyName + '様だけの特別割引一覧';
    }
  }

  @Emit()
  private setData(data: ApiPostsSpecialoffer): void {
    this.offers = data.datas;
  }
  @Emit()
  private async getEntries() {
    if (this.loading) return;
    try {
      this.loading = true;
      const result = await fetchSpecialOffer({
        lang: `${this.lang}`,
        offset: 0,
        length: 99,
      })
      .then( (response) => {
        this.setData(response);
        return true;
      })
      .catch( (e) => {
        console.error(e);
        return false;
      });
      return result;
    } catch(e) {
      return false;
    } finally {
      this.loading = false;
    }
  }
}
